import { CaptureJob } from "@components/ChartCapture/types";

export const captureJobLabel = (job: CaptureJob): string =>
  job.kind === "goal" ? job.goal.goalName ?? "Goal" : job.target.targetName ?? "Target";
